
<div class="terminal-sync-log-component-container page-root-container">
  <div class="page-header">
    <div class="page-title">
      <img class="icon" src="assets/images/menu/svg/pos-sync-log.svg">
      <span class="title">Terminal Sync</span>
    </div>
    <div class="page-actions">

    </div>
  </div>
  <div class="data-container ">
    <app-loader [show]="isLoading"></app-loader>
    <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter"
      (page)="onPageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
    </app-search-filter>
    <section tabindex="0" class="table-container">
      <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef class="item-header">#</th>
          <td mat-cell *matCellDef="let log; let i = index" class="item-column">{{
            (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="shop_name">
          <th mat-sort-header="shop.name" mat-header-cell *matHeaderCellDef>Shop</th>
          <td mat-cell *matCellDef="let log">{{log.shop_name}} [{{log.shop_code}}]</td>
        </ng-container>
        <ng-container matColumnDef="station_name">
          <th mat-sort-header="sync_process_log.station_name" mat-header-cell *matHeaderCellDef>Station</th>
          <td mat-cell *matCellDef="let log">{{log.station_name}} [{{log.station_code}}]</td>
        </ng-container>
        <ng-container matColumnDef="updated_at">
          <th mat-sort-header="sync_process_log.updated_at" mat-header-cell *matHeaderCellDef>Sync Time</th>
          <td mat-cell *matCellDef="let log">{{ log.updated_at | date:'dd MMM yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-sort-header="sync_process_log.status" mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let log">
            <div *ngIf="log.status === 1" class="status success">
              Success <span></span>
            </div>
            <div *ngIf="log.status === 0" class="status failed">
              Failed
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
        </tr>
        <tr mat-row class="table-element-row" *matRowDef="let log; columns: displayedColumns;"
          (click)="onRowSelected(log)" [ngClass]=" {'row-selected' : log.id===selectedItem?.id}">
        </tr>
      </table>
    </section>

    <!-- </ng-container> -->
    <!-- <ng-template #nodata> -->
    @if(pagingData.length<=0){ <div class="no-data-container">
      <img src="assets/images/no-data.png">
      <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
  </div> }
</div>
</div>